import React from "react";
import { Link } from "react-router-dom";
import useNotebookSidebar from "./use-notebook-sidebar";

const BASE_CLASS_NAME = "c-notebook-sidebar";

const SharedPagePanel = ({ page, notebook }) => {
    const { pageRoute, getPageClassModifier } = useNotebookSidebar();
    return (
        <div
            className={`${BASE_CLASS_NAME}__pagePanel ${getPageClassModifier(page.id)}`}>
            <Link
                to={pageRoute(page.id, notebook.id)!}
                className={`${BASE_CLASS_NAME}__link -page`}>
                <span>{page.name}</span>
            </Link>
        </div>
    );
};

export default SharedPagePanel;
